import { all, call, put, take, takeLatest, takeEvery } from "redux-saga/effects";
import { LOCATION_CHANGE } from "connected-react-router";

import * as actions from "../constants/actions";
import * as actionTypes from "../constants/actionTypes";
import * as folders from "./folders";
import * as models from "./models";
import * as modelExports from "./modelExports";
import * as editor from "./editor";
import * as auth from "./auth";
import * as user from "./user";
import * as contacts from "./contacts";
import * as route from "./routes";

function* watchAuthChange() {
  const channel = yield call(auth.createAuthChannel);

  while (true) {
    const { uid } = yield take(channel);
    const loggedIn = !!uid;

    yield put(actions.setLoaded({ loggedIn, uid }));

    if (loggedIn) {
      yield put(actions.fetchUser({ id: uid }));
    }
  }
}

export default function* rootSaga() {
  yield all([
    watchAuthChange(),
    takeEvery(LOCATION_CHANGE, route.route),
    takeLatest(actionTypes.FETCH_USER_ADMIN_RESOURCES, user.fetchUserAdminResources),
    takeLatest(actionTypes.FETCH_USER, user.fetchUser),
    takeLatest(actionTypes.DELETE_USER, user.deleteUser),
    takeLatest(actionTypes.UPDATE_USER, user.updateUser),
    takeLatest(actionTypes.UPDATE_USER_HAS_VISITED, user.updateUserHasVisited),
    takeLatest(actionTypes.SIGNUP, auth.signup),
    takeLatest(actionTypes.SIGNIN, auth.signin),
    takeLatest(actionTypes.SECURITY_SIGNIN, auth.securitySignin),
    takeLatest(actionTypes.SIGNOUT, auth.signout),
    takeLatest(actionTypes.RESET_PASSWORD, auth.resetPassword),
    takeLatest(actionTypes.CREATE_EDITOR_CONFIGS, editor.createEditorConfigs),
    takeLatest(actionTypes.SAVE_EDITOR_CONFIGS, editor.saveEditorConfigs),
    takeLatest(actionTypes.CREATE_FOLDER, folders.createFolder),
    takeLatest(actionTypes.UPDATE_FOLDER, folders.updateFolder),
    takeLatest(actionTypes.FETCH_FOLDERS, folders.fetchFolders),
    takeLatest(actionTypes.DELETE_FOLDER, folders.deleteFolder),
    takeLatest(actionTypes.CREATE_MODEL, models.createModel),
    takeLatest(actionTypes.UPDATE_MODEL, models.updateModel),
    takeLatest(actionTypes.FETCH_MODELS, models.fetchModels),
    takeLatest(actionTypes.FETCH_MODEL, models.fetchModel),
    takeLatest(actionTypes.DELETE_MODEL, models.deleteModel),
    takeLatest(actionTypes.CREATE_MODEL_EXPORT, modelExports.createModelExport),
    takeLatest(actionTypes.FETCH_MODEL_EXPORT, modelExports.fetchModelExport),
    takeLatest(actionTypes.CREATE_CONTACT, contacts.createContact),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js